import React, { useEffect, useState } from "react";
import CarList from "./components/CarList/CarList";
import { Car } from "./components/CarCard/CarCard";
import { CAR_IMAGE_VIEWS } from "./components/CarImageModal/CarImageModal";

const App: React.FC = () => {
  const [cars, setCars] = useState<Car[]>([]);

  useEffect(() => {
    fetch("/data/cars.json?v=1234")
      .then((res) => res.json())
      .then((data: Car[]) =>
        setCars(
          data.map((car) => ({
            ...car,
            images:
              Array.isArray(car.images) && car.images.length > 0
                ? car.images
                : CAR_IMAGE_VIEWS.map(
                    (view) => `${car.registration}-${view}.jpg`
                  ),
          }))
        )
      );
  }, []);

  useEffect(() => {
    function migrateFavoritesFormat(): void {
      const raw = localStorage.getItem("favorites");

      if (!raw) return;

      try {
        const parsed = JSON.parse(raw);

        // If it's already an array, return as-is
        if (Array.isArray(parsed)) {
          return;
        }

        // If it's an object, convert keys to numbers
        if (typeof parsed === "object" && parsed !== null) {
          const migrated = Object.keys(parsed).map((id) => parseInt(id, 10));
          localStorage.setItem("favorites", JSON.stringify(migrated));
          return;
        }

        // If it's neither, return empty array
        return;
      } catch {
        // If JSON parsing fails, clear and return empty
        localStorage.setItem("favorites", JSON.stringify([]));
        return;
      }
    }

    migrateFavoritesFormat();
  }, []);

  return (
    <div className="container mt-5">
      <CarList cars={cars} />
    </div>
  );
};

export default App;
